import Input, { SearchIcon, ArrowIcon, ClearIcon } from './input';
export default Input;

export {
	SearchIcon,
	ArrowIcon,
	ClearIcon,
};
